// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { message, Modal } from 'antd'
import { get, includes, defaultTo, isNil } from 'lodash'

// Ressources
import { actions as scanActions } from 'Resources/ScanResource'

// Common components
import { ManageModal } from 'Components'

// Specs
import { ModalSpecs } from 'Views/Scans/Specs'

// Ãcrans
import { List } from './Screens'

const { confirm } = Modal

class ScansConstructor extends Component {
  static propTypes = {
    // Actions d'API
    actions: PropTypes.object,

    // Utilisateur connectÃ©
    profile: PropTypes.object,

    // DonnÃ©es de la vue
    scan: PropTypes.object,
    scans: PropTypes.array,

    // TÃ©moin d'activitÃ© API
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool,
    isCreating: PropTypes.bool,

    // Navigation interne
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired,
      setParams: PropTypes.func.isRequired
    })
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // Utilisateur connectÃ©
    profile: {},

    // DonnÃ©es de la vue
    scan: {},
    scans: [],

    // TÃ©moin d'activitÃ© API
    isGathering: false,
    isUpdating: false,
    isCreating: false
  }

  constructor(props) {
    super(props)

    this.state = {
      openedModal: null
    }
  }

  componentDidMount = () => {
    // RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
    this.fetchScansData()

    if (this.getContext() === 'single') {
      this.getScanData().then(this.askUpdateScan)
    }
  }

  /**
   * RÃ©cupÃ©ration du contexte actuel du constructeur de page
   */
  getContext = () => {
    return isNil(this.props.navigation.getParam('id')) ? 'list' : 'single'
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
   */
  fetchScansData = () => {
    this.props.actions.fetchScans().catch(() => {
      message.error(I18n.t('api.errors.scan.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'un Ã©lÃ©ment de la vue
   */
  getScanData = (scan = this.props.navigation.getParam('id')) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .getScan(scan)
        .then(response => {
          // DÃ©tails rÃ©cupÃ©rÃ©s
          resolve(get(response, 'body'), response)
        })
        .catch(error => {
          // Erreur lors du refresh
          reject(error)
          message.error(I18n.t('api.errors.scan.get'))
        })
    })

  /**
   * Actions groupÃ©es:
   * Archivage de plusieurs lignes du tableau
   */
  archiveManyScan = (scan, clearTableSelections) => {
    this.props.actions
      .archiveManyScan(scan)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.scan.bulk.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scan.bulk.archive'))
      })
  }

  /**
   * Archivage d'une ligne du tableau
   */
  archiveScan = scan => {
    this.props.actions
      .archiveScan(scan)
      .then(() => {
        this.safelyCloseModal()
        this.props.navigation.setParams({ id: null })
        message.success(I18n.t('api.success.scan.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scan.archive'))
      })
  }

  /**
   * Actions groupÃ©es:
   * Suppression de plusieurs lignes du tableau
   */
  deleteManyScan = (scan, clearTableSelections) => {
    this.props.actions
      .archiveScans(scan)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.scan.bulk.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scan.bulk.delete'))
      })
  }

  /**
   * Suppression d'une ligne du tableau
   */
  deleteScan = scan => {
    this.props.actions
      .archiveScan(scan)
      .then(() => {
        this.safelyCloseModal()
        this.props.navigation.setParams({ id: null })
        message.success(I18n.t('api.success.scan.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scan.delete'))
      })
  }

  /**
   * Mise Ã  jour d'un scan
   */
  updateScan = (updatedScan, originalScan) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .updateScan({
          id: get(originalScan, 'id'),
          ...updatedScan
        })
        .then(response => {
          this.safelyCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.scan.update'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.scan.update'))
        })
    })

  /**
   * CrÃ©ation d'un scan
   */
  createScan = createdScan => {
    createdScan.validityPeriod = {
      startDate: createdScan.validityPeriod[0].format('YYYY-MM-DD HH:mm:ss'),
      endDate: createdScan.validityPeriod[1].format('YYYY-MM-DD HH:mm:ss')
    }
    this.props.actions
      .createScan(createdScan)
      .then(response => {
        this.safelyCloseModal()
        this.fetchScansData()
        message.success(I18n.t('api.success.scan.create'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scan.create'))
      })
  }

  /**
   * Actions groupÃ©es:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askArchiveManyScans = (...params) => {
    confirm({
      title: I18n.t('pages.scans.modal.archive.multiple.title'),
      content: I18n.t('pages.scans.modal.archive.multiple.content'),
      okText: I18n.t('pages.scans.modal.archive.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scans.modal.archive.multiple.cancelText'),
      onOk: () => {
        this.archiveScan(...params)
      },
      maskClosable: true
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askArchiveScan = () => {
    const { scan } = this.props

    confirm({
      title: I18n.t('pages.scans.modal.archive.single.title'),
      content: I18n.t('pages.scans.modal.archive.single.content'),
      okText: I18n.t('pages.scans.modal.archive.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scans.modal.archive.single.cancelText'),
      onOk: () => {
        this.archiveScan(scan)
      },
      maskClosable: true
    })
  }

  /**
   * Actions groupÃ©es:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askDeleteManyScans = (...params) => {
    confirm({
      title: I18n.t('pages.scans.modal.delete.multiple.title'),
      content: I18n.t('pages.scans.modal.delete.multiple.content'),
      okText: I18n.t('pages.scans.modal.delete.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scans.modal.delete.multiple.cancelText'),
      onOk: () => {
        this.deleteManyScan(...params)
      },
      maskClosable: true
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askDeleteScan = () => {
    const { scan } = this.props

    confirm({
      title: I18n.t('pages.scans.modal.delete.single.title'),
      content: I18n.t('pages.scans.modal.delete.single.content'),
      okText: I18n.t('pages.scans.modal.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scans.modal.delete.single.cancelText'),
      onOk: () => {
        this.deleteScan(scan)
      },
      maskClosable: true
    })
  }

  /**
   * Demande de modification d'une ligne du tableau
   */
  askUpdateScan = () => {
    this.setState({ openedModal: 'updateScan' })
  }

  /**
   * Demande de crÃ©ation d'une ligne du tableau
   */
  askCreateScan = () => {
    this.setState({ openedModal: 'createScan' })
  }

  /**
   * Fermeture de toutes les modales
   */
  safelyCloseModal = () => {
    const { openedModal } = this.state

    if (openedModal === 'updateScan') {
      this.setState({ openedModal: 'transition' }, () => {
        setTimeout(
          this.setState({ openedModal: null }, () => {
            this.props.navigation.setParams({ id: null })
          }),
          200
        )
      })
    } else {
      this.setState({ openedModal: null })
    }
  }

  /**
   * Callback:
   * CrÃ©ation d'une ligne de tableau rÃ©ussie
   */
  handleRowCreated = () => {
    this.safelyCloseModal()
  }

  /**
   * Callback:
   * Modification d'une ligne de tableau rÃ©ussie
   */
  handleRowUpdated = () => {
    this.safelyCloseModal()
  }

  /**
   * Clic sur une ligne du tableau
   */
  handleRowClick = scan => {
    // Navigation vers la page dÃ©taillÃ©e
    // this.props.navigation.setParams({ id: get(scan, 'id') })

    this.getScanData(scan).then(({ url }) =>
      // Ouverture de la modale
      // this.askUpdateScan()

      // Ouverture du fichier dans un nouvel onglet
      window.open(url, '_blank')
    )

    // Ouverture du drawer
    // this.setState({ drawerOpened: true })

    // Navigation vers la vue dÃ©taillÃ©e
    // this.props.navigation.navigate('Scan', { id: get(scan, 'id') })
  }

  /**
   * Formatage des lignes de la modale de modification / crÃ©ation
   */
  formatModalRows = rows => {
    return rows
  }

  render() {
    // RÃ©cupÃ©ration des Ã©lÃ©ments des props
    let {
      isGathering,
      isUpdating,
      isCreating,
      scans,
      scan,
      profile
    } = this.props

    // RÃ©cupÃ©ration des Ã©lÃ©ments du state
    const { openedModal } = this.state

    // Chargement
    const loading = isGathering || isUpdating || isCreating

    // CrÃ©ation de la liste des fonctions constructeur exposÃ©s au Ã©crans
    const constructorFunctions = {
      // Clic sur un ligne de tableau
      handleRowClick: this.handleRowClick,

      // Gestion de la modale
      safelyCloseModal: this.safelyCloseModal,

      // RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'une ligne du tableau
      getScanData: this.getScanData,

      // CrÃ©ation d'une ligne de tableau
      handleRowCreated: this.handleRowCreated,
      askCreateScan: this.askCreateScan,

      // Modification d'une ou plusieurs ligne(s) de tableau
      handleRowUpdated: this.handleRowUpdated,
      askUpdateScan: this.askUpdateScan,
      askUpdateManyScans: this.askUpdateScan,

      // Archivage d'une ou plusieurs ligne(s) du tableau
      askArchiveScan: this.askArchiveScan,
      askArchiveManyScans: this.askArchiveManyScans,

      // Suppression d'une ou plusieurs ligne(s) du tableau
      askDeleteScan: this.askDeleteScan,
      askDeleteManyScans: this.askDeleteManyScans,

      // RÃ©initialisation du mot de passe d'un scan
      askResetPasswordScan: this.askResetPasswordScan
    }

    // Ajout des actions sur la modale
    ModalSpecs.actions.delete.onClick = this.askDeleteScan

    // Ajout des lignes au formulaire
    // formLayout = merge(formLayout, manageModal)

    return (
      <Fragment>
        {/* Rendu de l'Ã©cran appropriÃ© au contexte du constructeur */}
        <List
          loading={loading}
          profile={profile}
          constructorFunctions={constructorFunctions}
          constructorState={this.state}
          dataList={scans}
        />

        {/* Ouverture de la modale de crÃ©ation / modification */}
        <ManageModal
          width={800}
          loading={loading}
          onCancel={this.safelyCloseModal}
          onOk={this.handleRowCreated}
          onChange={
            openedModal === 'updateScan' ? this.updateScan : this.createScan
          }
          visible={includes(['createScan', 'updateScan'], openedModal)}
          data={
            includes(['transition', 'updateScan'], openedModal) ? scan : null
          }
          {...ModalSpecs}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(ScansConstructor, 'defaultProps', {})

  return {
    scans: defaultTo(get(state, 'scan.items'), defaultProps.scans),
    scan: defaultTo(get(state, 'scan.item'), defaultProps.scan),
    profile: defaultTo(get(state, 'profile.item'), defaultProps.profile),
    isGathering:
      defaultTo(get(state, 'scan.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'scan.isFetchingItem'), defaultProps.isGathering),
    isUpdating: defaultTo(
      get(state, 'scan.isUpdating'),
      defaultProps.isUpdating
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...scanActions }, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScansConstructor)
